import React, { useEffect } from 'react';
import { Button, Form, Input, message } from 'antd';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import useAuthContext from '../../contexts/AuthContext';

const { TextArea } = Input;

export const IHaveAQuestion = ({ setCallMeBack, handleModalClose }) => {
  const [form] = Form.useForm();
  const { dispatchAPI, user } = useAuthContext();
  const { t } = useTranslation();

  const SendMailForHaveAQuestion = async (body) => {
    try {
      const { data } = await dispatchAPI('POST', {
        url: '/reclamations/ihaveaquestion',
        body
      });
      if (data.description) message.success(data.description);
      setCallMeBack(false);
    } catch (e) {
      if (e.response) message.error(e.response.status);
    }
  };
  const handleSubmit = (values) => {
    SendMailForHaveAQuestion(values);
    handleModalClose();
  };

  useEffect(() => {
    if (user)
      form.setFieldsValue({ ...user.insurer, object: 'Merci de me contacter' });

    // eslint-disable-next-line
  }, []);
  return (
    <Form
      name="i_have_a_question"
      form={form}
      labelCol={{ span: 8 }}
      wrapperCol={{ span: 8 }}
      onFinish={handleSubmit}
      autoComplete="off"
    >
      <Form.Item label={t('basiclayout.footer.name_office')} name="name">
        <Input />
      </Form.Item>
      <Form.Item
        label={t('basiclayout.footer.first_name')}
        name="owner_first_name"
      >
        <Input />
      </Form.Item>
      <Form.Item
        label={t('basiclayout.footer.last_name')}
        name="owner_last_name"
      >
        <Input />
      </Form.Item>

      <Form.Item
        label={t('basiclayout.footer.phone_number')}
        name="phone_number"
      >
        <Input />
      </Form.Item>
      <Form.Item label={t('basiclayout.footer.email')} name="owner_email">
        <Input />
      </Form.Item>
      <Form.Item label={t('basiclayout.footer.object')} name="object">
        <Input />
      </Form.Item>
      <Form.Item label={t('basiclayout.footer.message')} name="content">
        <TextArea />
      </Form.Item>

      <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
        <Button type="primary" htmlType="submit">
          Envoyer
        </Button>
      </Form.Item>
    </Form>
  );
};

IHaveAQuestion.propTypes = {
  setCallMeBack: PropTypes.func.isRequired,
  handleModalClose: PropTypes.func.isRequired
};

export default IHaveAQuestion;
